import React,  { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button, Checkbox, TextField } from '@mui/material';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleLogin = async(e) => {
        e.preventDefault();

        //Authentication logic 
        if(!validateEmail(email)){
            setError('Please enter a valid email.');
            return;
        }
        if(password.length < 6) {
            setError('Password must be at least 6 characters.');
        }
        try {
            const response = await fetch('http://localhost:8081/api/users/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({email, password})
            });

            if(response.ok) {
                const data = await response.json();
                console.log('Login userful:', data);

                localStorage.setItem('token', data.token);
                localStorage.setItem('user',JSON.stringify(data.user));
            
                navigate('/home');
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'login failed.');
                throw new Error('Invalid credentials');
            }

            const data = await response.json();
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.userDetails));
            
            setError('');
            navigate('/home');
        } catch(err) {
            console.error(err);
            setError('Login failed. Please check your email and password.');
        }       
    };
   
    return(
        <div style={{ padding:  '20px', textAlign: 'center'}}>
             {error && <p style={{ color: 'red' }}>{error}</p>}
            <h1>Login</h1>
            <form onSubmit={handleLogin}>
                <div>
                    <TextField  
                    label="Email"                  
                    type="email" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                    required>
                    </TextField>
                </div>
                <div>
                <TextField                    
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    variant="outlined"
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    required>
                </TextField>
                </div>
                <Button  type="submit">Login</Button>
                <Button  type="Button" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? 'Hide' : 'Show'}
                </Button>
                <Checkbox id="rememberMe"
                onChange={(e) => console.log('Remember Me:', e.target.checked)}
                />
                <label htmlFor="rememberMe">Remember Me</label> 
            </form> 

            <p>Don't have an account? <Link to="/register">Sign up here</Link></p>  
            {error && <p style={{ color: 'red' }}>{error}</p>}         
        </div>
    );
};

export default LoginPage; 